import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {PollResult, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {poll} from 'common/src/modules/shared/copilot/utils/poll';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CreativesManagerAgentToolName} from '../creativesManagerAgent.enums';

const inputSchema = z.object({});

function navigateToCreativesLibraryTool(store: CLStore) {
  function _isCreativesLibraryDataReady(): PollResult {
    if (
      store.getState().application.breadcrumbs.includes(BreadcrumbName.CreativesLibrary) &&
      store.getState().creativesLibrary.creatives.length
    ) {
      return {passed: true};
    }

    return {passed: false, reason: 'Creatives library failed to load'};
  }

  async function execute(): Promise<ToolResult> {
    routingService.goTo({
      url: Routes.CreativesLibrary,
    });

    const result = await poll({checkFn: _isCreativesLibraryDataReady});

    return toolResult(result.passed ? `Navigated to creatives library` : result.reason);
  }

  return tool({
    name: CreativesManagerAgentToolName.NavigateToCreativesLibrary,
    description: 'Navigate to creatives library',
    displayName: 'Navigating',
    execute,
    inputSchema,
  });
}

export default navigateToCreativesLibraryTool;
